import { render } from "./SkeletonCardLoading.vue?vue&type=template&id=4458d71f"
import script from "./SkeletonCardLoading.vue?vue&type=script&lang=js"
export * from "./SkeletonCardLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__